import { UserPlus, ShoppingBag, Banknote } from 'lucide-react';
import { PageTour } from '@/components/common/PageTour';

/**
 * 3-step Customers walkthrough — covers the canonical receivables flow:
 *   1. Add a customer (with credit limit + loyalty)
 *   2. Record a credit sale
 *   3. Receive a payment (and watch the cashflow movers)
 *
 * Triggered by the Customers info callout's "Show me around" button.
 */
const STEPS = [
  {
    icon: UserPlus,
    title: '1. Add a customer',
    body: (
      <>
        Click <strong>+ Add Customer</strong> and capture name, phone, and an optional <strong>credit limit</strong>.
        If you run a loyalty program, the customer auto-enrols and earns points on every paid sale — visible in
        the customer detail and on receipts.
      </>
    ),
  },
  {
    icon: ShoppingBag,
    title: '2. Record a credit sale',
    body: (
      <>
        At the POS, search the customer and pick payment method <strong>Credit</strong>. Their current balance
        ticks up; the receipt shows the running outstanding. You can also import historical invoices via the
        bulk-import flow if you&apos;re onboarding from another system.
      </>
    ),
  },
  {
    icon: Banknote,
    title: '3. Receive a payment',
    body: (
      <>
        Hit <strong>Receive Payment</strong> on the customer card. The amount auto-allocates against oldest invoices
        (FIFO) and the balance drops. The <strong>Cash flow movers</strong> panel up top highlights customers paying
        sharply faster (good — consider volume discount) or slower (chase before it becomes bad debt).
      </>
    ),
  },
];

export function CustomersTour({ open, onOpenChange }) {
  return (
    <PageTour
      open={open}
      onOpenChange={onOpenChange}
      steps={STEPS}
      tourName="Customers walkthrough"
      testidPrefix="customers-tour"
    />
  );
}
